/** External profile URLs for toolbar buttons — edit to match your accounts */
export const SOCIAL_URLS = {
    github: 'https://github.com/aoshumway8/knowledge-base',
    linkedin: 'https://www.linkedin.com/in/adam-shumway-93702324a/',
    medium: 'https://medium.com/@aoshumway8',
};
